export default __webpack_public_path__ + "static/media/Marianne-Regular_Italic.705c5430.woff2";